module.exports = __webpack_public_path__ + "img/login-welcome.7a424d93.svg";